// Shopify App Store installs must stay on the Shopify funnel: the backend
// classifies these signups as source=shopify and would discard an "agent"
// funnel choice anyway, so offering the switch would be a bait-and-switch.
const shopifyInstallIntentParams = [
  "nonce",
  "shopify_shop_url",
  "shopifyIntegrationId",
  "pendingAppInstallationId",
];

export function hasShopifyInstallIntent(
  searchParams: URLSearchParams,
): boolean {
  return shopifyInstallIntentParams.some((param) => {
    return Boolean(searchParams.get(param));
  });
}

// Sent campaign emails tuck ?source=<code> inside a `next` back to /beta/enable, so read that first.
export function getCampaignSourceFromParams(
  searchParams: URLSearchParams,
): string | null {
  const next = searchParams.get("next");
  const queryStart = next?.indexOf("?") ?? -1;
  const sourceFromNext =
    next && queryStart !== -1
      ? new URLSearchParams(next.slice(queryStart + 1)).get("source")
      : null;
  // `||` on purpose: an empty source= is treated as absent, not logged as "".
  return sourceFromNext || searchParams.get("source") || null;
}
